module.exports = __webpack_public_path__ + "img/d.f72248ba.jpg";